export const CLICK_FUNNEL_OFFER_TYPE = "clickfunnel";

export type LaunchableOffer = {
  launchOfferType?: string;
  isProductCatalog?: boolean;
};

/**
 * Whether an offer still has a working checkout to link to.
 *
 * The Chargify-era checkout `/onboard/place-order/:offerCode` in afy-ui is
 * retired (hubspot-off-block-3 task 98): nginx answers it with a 301 to the
 * pricing page. Only ClickFunnels offers (`launchOfferType: 'clickfunnel'`)
 * and product-catalog offers can be launched or given a UTM link.
 *
 * `isProductCatalog` is reliable here: DS `GET /v1/product-catalog/offers`
 * returns raw aggregate documents, and only the product-catalog offers carry
 * the field.
 */
export const canLaunchOffer = (offer?: LaunchableOffer | null): boolean =>
  offer?.launchOfferType === CLICK_FUNNEL_OFFER_TYPE ||
  offer?.isProductCatalog === true;
